module.exports = __webpack_public_path__ + "static/media/8043832251_3aebd31aed_z.1dd7bfee.jpg";